'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExternalLink = function ExternalLink(_ref) {
  var href = _ref.href,
      text = _ref.text;
  return _react2.default.createElement(
    'a',
    {
      target: '_blank',
      rel: 'noopener noreferrer',
      href: href
    },
    text
  );
};

ExternalLink.propTypes = {
  href: _propTypes2.default.string.isRequired,
  text: _propTypes2.default.string.isRequired
};

exports.default = ExternalLink;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SurflineFooter/ExternalLink.js
// module id = 327
// module chunks = 0